import { createElement } from 'react';
import logo from './SHIMANO-CONCEPT-FONDO-BLANCO.jpg';
import logof from './logo_SSC_F.png';

const LogoSSC = () => {
    const isBrowser = typeof window !== 'undefined';

    const filialSelecionada = isBrowser ? sessionStorage.getItem('_filialSelecionada') : null;
    const currentPath = isBrowser ? window.location.pathname : '';

    let logoSrc = logo; 

    if (filialSelecionada === '2') {
        logoSrc = logo;
    } else if (filialSelecionada === '6') {
        logoSrc = logof;
    } else if (!filialSelecionada) {
        if (currentPath.includes('/service-point')) {
            logoSrc = logof;
        }
    }

    const href = filialSelecionada === '6' || (!filialSelecionada && currentPath.includes('/service-point'))
        ? '/service-point'
        : '/service-center';

    return createElement(
        'a',
        {
            href,
            tabIndex: 0,
            className: 'logo-SSC',
            'aria-label': 'Logo SSC, haga clic para redirigir a la página del Service Center'
        },
        createElement('img', {
            src: logoSrc,
            alt: 'Logo SSC'
        })
    );
};

export default LogoSSC;
